import { SidebarGroup, SidebarGroupContent } from '@/components/ui/sidebar';

import { MainSidebarContent } from '@/components/nav-main-content';
import type { NavSection } from '@/components/app-sidebar/navigation-data';
import { Suspense } from 'react';

export function NavMain({ items = [] }: { items: NavSection[] }) {
  return (
    <SidebarGroup>
      <SidebarGroupContent className="flex flex-col gap-2">
        <Suspense fallback={null}>
          <MainSidebarContent items={items} />
        </Suspense>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
